<template>
    <v-row row wrap>
        <template v-if="prices && prices.mahdollinen !== false">
            <v-col cols="12" md="6" class="pb-1">
                <div class="result-title">Käyttöönottokustannukset</div>
                <div></div>
                <div class="result-text">{{ round(prices.kayttoonottokustannukset) }}€
                    <span v-if="prices.alkaen != null"
                          class="result-caption">(alk. {{ round(prices.alkaen) }}€/kk)</span></div>
                <div v-if="showPromotionNote">
                    <v-chip color="#FFF8CC" style="font-weight: 500; margin-right: 5px;">
                      Hinnassa ei ole huomioitu tukia tai alennuksia.
                    </v-chip>
                </div>
            </v-col>
            <v-col cols="12" md="6" class="pb-1">
                <div class="result-title">Energian kokonaiskustannukset vuodessa</div>
                <div class="result-text">{{ round(prices.energia_kokonaiskustannukset_vuodessa) }}€</div>
            </v-col>
            <v-col cols="12" md="6" class="pb-1">
                <div class="result-title">CO2 päästöt vuodessa</div>
                <div class="result-text">{{ round(prices.co2_vuodessa) }} kg</div>
            </v-col>
            <template v-if="powerConsumption">
                <v-col cols="12" md="6" class="pb-1">
                    <div class="result-title">Arvio liittymätehosta</div>
                    <div class="result-text">{{ powerConsumption }} kW</div>
                </v-col>
            </template>
            <template v-if="compareResult">
                <v-col cols="12" md="6" class="pb-1">
                    <div class="result-title">Takaisinmaksuaika</div>
                    <div class="result-text">
                        <template v-if="paybackTime > 0">
                            {{ round(paybackTime) }} vuotta
                        </template>
                        <template v-else>
                            Ei kannattava
                        </template>
                    </div>
                </v-col>
                <v-col cols="12" md="6" class="pb-1">
                    <div class="result-title">Säästöt vuosittain</div>
                    <div class="result-text">
                        <template v-if="paybackTime > 0">
                            {{ round(savingsPerYear) }}€
                        </template>
                        <template v-else>
                            Ei säästöjä
                        </template>
                    </div>
                </v-col>
            </template>
        </template>
        <template v-if="prices && prices.mahdollinen === false">
            <v-col cols="12" md="12" class="pb-1">
                <div class="result-title">Ei vaihtoehtoja valituille arvoille</div>
            </v-col>
        </template>
    </v-row>
</template>

<script>
  import { round, subtract, divide } from 'mathjs';

  export default {
    name: "ResultFields",
    props: {
      main: {
        type: Boolean,
        default: false,
      },
      prices: {
        type: Object,
      },
      compareToPrices: {
        type: Object,
        default: null,
      },
      powerConsumption: {
        type: Number,
        default: null,
      },
    },
    methods: {
      round(value) {
        try {
          return round(value).toLocaleString('fi');
        } catch (error) {
          console.log(error);
          console.log(this.prices);
          return value;
        }
      },
    },
    computed: {
      showPromotionNote() {
        return this.main && this.$store.state.buildingType === 'okt' && this.$store.state.currentHeating === 'oljy';
      },
      paybackTime() {
        return divide(this.prices.kayttoonottokustannukset, this.savingsPerYear);
      },
      savingsPerYear() {
        return subtract(this.compareToPrices.kayttokustannukset_vuodessa, this.prices.kayttokustannukset_vuodessa);
      },
      compareResult() {
        return this.compareToPrices != null;
      },
    },
  }
</script>

<style lang="scss" scoped>
    .result-title {
        font-weight: 600;
        font-size: 18px;
        opacity: 0.9;
    }

    .result-text {
        font-weight: 600;
        font-size: 42px;
        line-height: 42px;
    }

    .result-caption {
        font-size: 24px;
    }

    .compare-results {
        .result-title {
            font-weight: 400;
            font-size: 14px;
            opacity: 1;
            text-transform: unset;
        }

        .result-text {
            font-size: 22px;
            line-height: 22px;
        }

        .result-caption {
            font-size: 14px;
        }
    }
</style>
